export function adjustCardHeights() {
    // Select all '.post-slider' elements
    const postSliders = document.querySelectorAll('.post-slider');
  
    postSliders.forEach(slider => {
      // Find all '.card' elements within the '.post-slider'
      const cards = slider.querySelectorAll('.card');
  
      if (cards.length > 0) {
        // Determine the tallest '.card' element
        let tallestHeight = 0;
        cards.forEach(card => {
          const cardHeight = card.offsetHeight;
          if (cardHeight > tallestHeight) {
            tallestHeight = cardHeight;
          }
        });
  
        // Set all '.card' elements to the tallest height
        cards.forEach(card => {
          card.style.height = `${tallestHeight}px`;
        });
      }
    });
  }
  
 export function observeDynamicElements() {
    // Use a MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver(() => {
      adjustCardHeights();
    });
  
    // Observe the entire document for child node additions
    observer.observe(document.body, { childList: true, subtree: true });
  }
  